import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import CreateIcon from '@material-ui/icons/Create';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SettingsIcon from '@material-ui/icons/Settings';

import defaultUser from '../../common/images/avatar.jpeg';

// import useBillingControl from '../../hooks/useBilling';
import { FlexBox } from '../Reusables';

const TopUserPopper = ({
  classes,
  openUser,
  anchorElUser,
  handleCloseUser,
  BusinessName,
  user,
  handleSettings,
  handleBilling,
  handleLogoutUser
}) => {
  return (
    <Box className={classes.popoverWrapperUser}>
      <Popover
        className={classes.dropdown}
        open={openUser}
        anchorEl={anchorElUser}
        onClose={handleCloseUser}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {/* <Grid container justify='flex-end'>
            <Grid item>
              <Box className={classes.edit}>
                Edit <EditIcon fontSize='small' />
              </Box>
            </Grid>
          </Grid> */}
        <Box className={classes.summary}>
          <FlexBox jc='normal' style={{ gap: 18 }}>
            <Avatar
              alt='business logo'
              src={
                BusinessName && BusinessName.logo !== null
                  ? BusinessName.logo
                  : defaultUser
              }
              className={classes.medium}
            />
            <Box>
              {user && (
                <>
                  <Typography variant='subtitle2'>
                    {`${user.first_name} ${user.last_name}`}
                  </Typography>
                  <Typography variant='subtitle1'>{`${user.email}`}</Typography>
                </>
              )}
            </Box>
          </FlexBox>
        </Box>

        <Grid container className={classes.menuPopoverUser}>
          <Grid item>
            {user && user.is_owner && (
              <FlexBox jc='normal' style={{ gap: 12, padding: 20 }}>
                <SettingsIcon />
                <Typography
                  variant='subtitle2'
                  className={classes.cta}
                  onClick={handleSettings}
                >
                  Settings
                </Typography>
              </FlexBox>
            )}{' '}
            <Divider />
            {user && user.is_owner && (
              <FlexBox jc='normal' style={{ gap: 12, padding: 20 }}>
                <CreateIcon />
                <Typography
                  variant='subtitle2'
                  className={classes.cta}
                  onClick={handleBilling}
                >
                  Billing
                </Typography>
              </FlexBox>
            )}
            <Divider />
            <FlexBox jc='normal' style={{ gap: 12, padding: 20 }}>
              <ExitToAppIcon />
              <Typography
                className={classes.cta}
                variant='subtitle2'
                onClick={handleLogoutUser}
              >
                Sign Out
              </Typography>
            </FlexBox>
          </Grid>
        </Grid>
      </Popover>
    </Box>
  );
};

export default TopUserPopper;
